import React,{  useState} from 'react'
import faqImg from '../../../assets/faqImg.jpeg';
import ActionIconItem from './action-icon-item';

export default function LandingAskUsPage() {

    const [expandedIndex, setExpandedIndex] = useState(null);
 
    const handleToggle = (index) => {
        if (expandedIndex === index) {
            setExpandedIndex(null);
        } else {
            setExpandedIndex(index);
        }
    };

    return (
        <div className=" mx-16 xl:m-auto max-w-[93rem] pb-28 max-xs:mx-0">
            <div className="">
                <div className="flex justify-center pt-20 pb-14 xl:pb-16 max-xs:pt-16  max-md:pb-8 max-lg:pb-8 font-sans font-semibold text-30 xl:text-40 max-xs:mx-8  max-xs:text-[1rem]">Frequently Asked Questions</div>
                <div className='flex items-start gap-[73px] xl:gap-[48px] max-xs:flex-col justify-center max-xs:items-center'>
                        <img className='w-[429px] h-[358px] xl:w-[590px] xl:h-[487.17px] max-xs:w-[290px] max-xs:h-[300px] mt-[41px] xl:mt-[66px] max-xs:m-0' src={faqImg} alt='faq img' />
                    <div className="flex flex-col justify-center font-sans font-normal text-18 gap-7  ">
                    <ActionIconItem
                          index={0}
                          isExpanded={expandedIndex === 0}
                          toggleAccordion={handleToggle}
                            title="Can I Paid Collaborations through Oye Creators?"
                            content={
                                <>
                                    Yes, you get only paid or barter collaborations through Oye Creators. Say  goodbye to freebies
                                </>
                            }
                        
                        />
                        <ActionIconItem
                          index={1}
                          isExpanded={expandedIndex === 1}
                          toggleAccordion={handleToggle}
                            title="How much money can a creator earn with one reel?"
                            content={
                                <>
                                    A creator can earn a minimum of ₹500 and a maximum of ₹5000 from one reel. Also, the
                                    pricing will depend on your Creator Scores
                                </>
                            }
                        />
                        <ActionIconItem
                          index={2}
                          isExpanded={expandedIndex === 2}
                          toggleAccordion={handleToggle}
                            title="Do you have creators who can do barter collaborations?"
                            content={
                                <>
                                    Yes, we have some creators who do barter, but it depends on what they are getting in exchange.
                                    It is entirely up to them if they want to do barter or not. We don't restrict our creators
                                </>
                            }
                        />
                        <ActionIconItem
                          index={3}
                          isExpanded={expandedIndex === 3}
                          toggleAccordion={handleToggle}
                            title="Is there any criterion for subscription or platform fees?"
                            content={
                                <>
                                    No, we are a no-commission platform, and as we follow outcome-based pricing,
                                    we don't have any subscription plans
                                </>
                            }
                        />
                        <ActionIconItem
                          index={4}
                          isExpanded={expandedIndex === 4}
                          toggleAccordion={handleToggle}
                            title="I am a fresher with less than 1k followers, can I register?"
                            content={
                                <>
                                    Yes, you can. We always welcome freshers and would appreciate it if they want to grow with us
                                </>
                            }
                        />
                        <ActionIconItem
                          index={5}
                          isExpanded={expandedIndex === 5}
                          toggleAccordion={handleToggle}
                            title="I have a private account, can I also get projects?"
                            content={
                                <>
                                    You can sign up with us, but getting a project is not guaranteed for you because Oye Creators
                                    post all the reels in collaboration, which in the case of private profiles, is restricted
                                </>
                            }
                        />
                    </div>
                </div>
            </div>
        </div >
    )
}
